import lazyElements from "../lazyElements/lazyElements";
import loadImageSrc from "./loadImageSrc";

/**
 * @param {array} images - array of images.
 * @param {function} callback - callback function triggered on image load.
 */
export default function watchForImages(images, lazyCallback, threshold = 0) {

    const callback = (entry, observer) => {
        let img = entry.target;
        loadImageSrc(img);
        if (lazyCallback) lazyCallback(img);
    }

    return lazyElements(images, callback, threshold);
}
